import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import * as FaIcons from "react-icons/fa";

export const dashboardSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: "27px",
        height: "27px",
        fontSize: "12px",
        borderColor: state.isFocused ? "var(--dashboard-accent, #8dbe22)" : "#ced4da",
        borderRadius: "10px",
        boxShadow: "none",
        cursor: "pointer",
        "&:hover": {
            borderColor: state.isFocused ? "var(--dashboard-accent, #8dbe22)" : "#aeb7c0"
        }
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: "25px",
        padding: "0 8px"
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "25px"
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: "3px 6px"
    }),
    clearIndicator: (provided) => ({
        ...provided,
        padding: "3px 6px"
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "var(--dashboard-text, #1d2024)"
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        fontSize: "12px",
        borderRadius: "8px",
        overflow: "hidden"
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999
    })
};

const getSelectedOption = (options, value) => {
    return options.find((option) => String(option.value) === String(value)) || options[0] || null;
};

const openDatePicker = (event) => {
    const input = event.currentTarget;
    if (typeof input.showPicker === "function") {
        input.showPicker();
    }
};

const DashboardFilters = ({
    presets,
    activePreset,
    customLabel,
    dateStart,
    dateEnd,
    maxDate,
    fromLabel,
    toLabel,
    searchLabel,
    errors,
    loading,
    selects,
    onApplyPreset,
    onDateChange,
    onSearch
}) => (
    <div className="dashboard-filter-surface">
        <div className="dashboard-filter-top">
            {presets.map((preset) => (
                <button
                    key={preset.value}
                    className={`dashboard-filter-chip ${activePreset === String(preset.value) ? "active" : ""}`}
                    type="button"
                    onClick={() => onApplyPreset(preset.value)}
                >
                    {preset.icon}
                    <span>{preset.label}</span>
                </button>
            ))}
            {customLabel && (
                <span className={`dashboard-filter-chip ${activePreset === "custom" ? "active" : ""}`}>
                    <FaIcons.FaSlidersH />
                    <span>{customLabel}</span>
                </span>
            )}
        </div>

        <div className="dashboard-filter-grid">
            <div className="dashboard-filter-field">
                <label>{fromLabel}</label>
                <input
                    type="date"
                    className="form-control inputStandard"
                    value={dateStart}
                    max={maxDate}
                    onClick={openDatePicker}
                    onChange={(event) => onDateChange("dateStart", event.target.value)}
                />
                {errors.dateStart && <div className="dashboard-filter-error">{errors.dateStart}</div>}
            </div>
            <div className="dashboard-filter-field">
                <label>{toLabel}</label>
                <input
                    type="date"
                    className="form-control inputStandard"
                    value={dateEnd}
                    max={maxDate}
                    onClick={openDatePicker}
                    onChange={(event) => onDateChange("dateEnd", event.target.value)}
                />
                {errors.dateEnd && <div className="dashboard-filter-error">{errors.dateEnd}</div>}
            </div>
            {selects.filter((select) => select.visible !== false).map((select) => (
                <div className="dashboard-filter-field" key={select.id}>
                    <label>{select.label}</label>
                    <Select
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuShouldScrollIntoView={false}
                        isDisabled={loading || select.disabled}
                        styles={dashboardSelectStyles}
                        options={select.options}
                        value={getSelectedOption(select.options, select.value)}
                        placeholder={select.placeholder}
                        onChange={(option) => select.onChange(option)}
                    />
                    {errors[select.id] && <div className="dashboard-filter-error">{errors[select.id]}</div>}
                </div>
            ))}
            <div className="dashboard-filter-actions">
                <button className="buttonMzateSecondary" type="button" onClick={onSearch}>
                    <FaIcons.FaSearch />
                    <span>{searchLabel}</span>
                </button>
            </div>
        </div>
    </div>
);

DashboardFilters.propTypes = {
    presets: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.node
    })),
    activePreset: PropTypes.string.isRequired,
    customLabel: PropTypes.string,
    dateStart: PropTypes.string.isRequired,
    dateEnd: PropTypes.string.isRequired,
    maxDate: PropTypes.string,
    fromLabel: PropTypes.string.isRequired,
    toLabel: PropTypes.string.isRequired,
    searchLabel: PropTypes.string.isRequired,
    errors: PropTypes.object,
    loading: PropTypes.bool,
    selects: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        options: PropTypes.array.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        visible: PropTypes.bool,
        onChange: PropTypes.func.isRequired
    })),
    onApplyPreset: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired
};

DashboardFilters.defaultProps = {
    presets: [],
    customLabel: "",
    maxDate: "",
    errors: {},
    loading: false,
    selects: []
};

export default DashboardFilters;
